export const FETCH_CONTRACT_SUCCESSFUL_MSG = "Contrato obtenido con éxito";
export const FETCH_CONTRACT_FAILURE_MSG = "Error durante la obtención del contrato";
export const FETCH_CRM_CASE_SUCCESSFUL_MSG = "Caso CRMs obtenido con éxito";
export const FETCH_CRM_CASE_FAILURE_MSG = "Error durante la obtención del caso CRM";
export const CREATE_CRM_CASE_SUCCESSFUL_MSG = "Caso CRM creado con éxito";
export const CREATE_CRM_CASE_FAILURE_MSG = "Error durante la creación del caso CRM";
